import { render, staticRenderFns } from "./SPSection.vue?vue&type=template&id=db772a6e"
import script from "./SPSection.vue?vue&type=script&lang=js"
export * from "./SPSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports